import React, { useEffect, useState } from "react";
import "./Home_TCV.css";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import BrandsContainer from "./BrandsContainer";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faStar } from '@fortawesome/free-solid-svg-icons'
import { Carousel } from 'react-responsive-carousel';
import { useHistory } from "react-router";
import AuthService from '../../utils/AuthService';
import { CloseBubble, OdeOliver } from "../Tools/OliverIcons";
import OliverHelper from "../../utils/Oliverhelper";

const Auth = new AuthService();

const country = process.env.REACT_APP_MP_COUNTRY;
let logeado = Auth.loggedIn();

var promosUno = [
  { alt: 'royal_canin', sourse: 'https://s3.sa-east-1.amazonaws.com/mispichos.com.ar/user-interface-assets/mar_logos_mx/banner_royalcanin.png', categ: 'marca', value_categ: 'Royal-Canin' },
  { alt: 'nupec', sourse: 'https://s3.sa-east-1.amazonaws.com/mispichos.com.ar/user-interface-assets/mar_logos_mx/banner_nupec.png', categ: 'marca', value_categ: 'Nupec' },
  { alt: 'hills', sourse: 'https://s3.sa-east-1.amazonaws.com/mispichos.com.ar/user-interface-assets/banner_s/mobile/hills_mobile.png', categ: 'marca', value_categ: 'Hills' },
  { alt: 'pro_plan', sourse: 'https://s3.sa-east-1.amazonaws.com/mispichos.com.ar/user-interface-assets/mar_logos_mx/banner_proplan.png', categ: 'marca', value_categ: 'Pro-Plan' },
  { alt: 'alimentos humedos', sourse: require('../../IMG/mobile_alimentos_húmedos.jpg'), categ: 'condicion', value_categ: 'humedo' },
  { alt: 'chateanos', sourse: require('../../IMG/mobile_prescripción_veterinaria.jpg'), categ: 'medicado', value_categ: 'si' },
]

var promosDos = [
  { alt: 'descuento', sourse: require('../../IMG/mobile_informativo_01.png') },
  { alt: 'Envio gratis', sourse: require('../../IMG/mobile_informativo_02.png') },
  { alt: 'compra segura', sourse: require('../../IMG/mobile_informativo_03.png') },
  { alt: 'envio rapido', sourse: require('../../IMG/mobile_informativo_04.png') },
  { alt: 'pago', sourse: require('../../IMG/mobile_informativo_05.png') },
  { alt: 'chateanos', sourse: require('../../IMG/mobile_informativo_06.png') },
]

var categoriasAr = [
  { image: 'https://mx.oliver.pet/static/media/alimentos_ar.474914a2.png', name: 'Alimento', linkTo: 'productos?categoria=croquetas' },
  { image: 'https://mx.oliver.pet/static/media/snacks_ar.485f96e2.png', name: 'Premios', linkTo: 'productos?categoria=premios' },
  { image: 'https://mx.oliver.pet/static/media/antipulgas_ar.d39d931d.png', name: 'Antipulgas', linkTo: 'productos?categoria=antipulgas' },
  { image: 'https://mx.oliver.pet/static/media/higiene_ar.a5ec8805.png', name: 'Higiene', linkTo: 'productos?categoria=higiene' },
  { image: 'data:image/png;base64,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', name: 'Veterinaria', linkTo: 'veterinarias' },
  { image: 'https://mx.oliver.pet/static/media/icono_seguro.cb406fde.png', name: 'Seguros', linkTo: 'registro' },
]

var categoriasMx = [
  { image: 'https://s3.sa-east-1.amazonaws.com/mispichos.com.ar/user-interface-assets/wo_elementos/alimento_mx.png', name: 'Croquetas', linkTo: 'brand-list' },
  { image: 'https://s3.sa-east-1.amazonaws.com/mispichos.com.ar/user-interface-assets/wo_elementos/snacks_mx.png', name: 'Premios', linkTo: 'productos?categoria=premios' },
  { image: require('../../IMG/antipulgas_ar.png'), name: 'Antipulgas', linkTo: 'productos?categoria=antipulgas' },
  { image: 'https://s3.sa-east-1.amazonaws.com/mispichos.com.ar/user-interface-assets/wo_elementos/higiene_mx.png', name: 'Higiene', linkTo: 'productos?categoria=higiene' },
  { image: 'data:image/png;base64,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', name: 'Veterinarias', linkTo: 'veterinarias' },
  { image: 'https://mx.oliver.pet/static/media/icono_seguro.cb406fde.png', name: 'Cobertura', linkTo: 'seguro' },
]

export default function HomeTCV() {
  useEffect(() => {
    OliverHelper.showPopupApp();
    document.title = 'Oliver pets: El Delivery De Tus Mascotas'
  }, [])
  return (
    <section className='BlueBox Home_TCV'>
      {!logeado && <LoginBox />}
      <CarouselPromotionalBanner data={promosUno} />
      <BrandsContainer />
      <Categorias data={country === 'MLA' ? categoriasAr : categoriasMx} />
      <CarouselComits />
      <CarouselBanner data={promosDos} />
      <TrustInUs />
    </section>
  )
}


const LoginBox = () => {
  const [esDeMisPichos, set_esDeMisPichos] = useState(false)
  const history = useHistory()

  return (
    <div id="LOGINBOX" >
      <button className='Card LoginBox' onClick={() => history.push('/registro')}>
        Ingresar / Crear cuenta
      </button>
    </div>
  )
}

const Categorias = ({ data }) => {
  const history = useHistory()

  return (
    <article className='Categorias'>
      <h4>¿Qué necesitas hoy?</h4>
      <div className="GridSeis">
        {data.map((cat, o) =>
          <div className='Card CatBox' onClick={() => history.push('/' + cat.linkTo)}>
            <img src={cat.image} alt={cat.linkTo} />
            <h5>
              {cat.name}
            </h5>
          </div>
        )}
      </div>
    </article>
  )
}

const CarouselBanner = ({ data }) => {

  if (!data) return null

  return (
    <div className='CarouselBanner'>
      <h4>Por qué elegirnos</h4>

      <Carousel
        showArrows={false}
        showStatus={false}
        showIndicators={true}
        showThumbs={false}
        swipeable
        autoPlay={true}
        infiniteLoop={true}
        stopOnHover={false}
      /*onClickItem={i => {
        if (i === 2) {
          this.props.history.push('/politicas-envios');
        } else if (i === 3) {
          this.chatOpen();
        }
      }}*/
      >
        {data.map((item, i) =>
          <img alt={item.alt} src={item.sourse} />
        )}
      </Carousel>
    </div>
  )
}

const CarouselComits = () => {

  var comentarios = [
    {
      name: 'Isabel A.',
      sourse: 'https://s3.sa-east-1.amazonaws.com/mispichos.com.ar/user-interface-assets/wo_elementos/caro-min.png',
      date: 'Desde Condesa. 20/08/2021',
      comentario: 'Son de lo más profesional, sus entregas son oportunas y brindan una atención fantástica. Gracias por tan buen servicio.'
    },
    {
      name: 'Marcela C.',
      sourse: 'https://s3.sa-east-1.amazonaws.com/mispichos.com.ar/user-interface-assets/wo_elementos/luz-min.png',
      date: 'Desde Iztacalco. 18/01/2021',
      comentario: 'Me ayudaron a corregir el error que cometí al hacer la compra, Altamente agradecida con el servicio, un gusto comprar acá.'
    },
    {
      name: 'Ivana H.',
      sourse: 'https://s3.sa-east-1.amazonaws.com/mispichos.com.ar/user-interface-assets/wo_elementos/rocio-min.png',
      date: 'Desde Polanco. 15/07/2021',
      comentario: 'Excelente atención Me urgía comprar las croquetas de Gala y llegaron en menos de 3 horas, sin duda seguiré comprando.'
    },
    {
      name: 'Manuel B.',
      sourse: 'https://s3.sa-east-1.amazonaws.com/mispichos.com.ar/user-interface-assets/wo_elementos/nov_luz-min.png',
      date: 'Desde Navarte. 12/05/2021',
      comentario: 'Super fácil el proceso de compra, precios bajos y recibí en el mismo día. Mi perrito se los agradece mucho y yo también.'
    },
    {
      name: 'Luis T.',
      sourse: 'https://s3.sa-east-1.amazonaws.com/mispichos.com.ar/user-interface-assets/wo_elementos/max-min.png',
      date: 'Desde Insurgentes. 22/04/2021',
      comentario: 'Necesitaba cambiar las croquetas de mi gata y en el chat me asesoraron muy bien ¡me atendieron en segundos!'
    },
    {
      name: 'Omar U.',
      sourse: 'https://s3.sa-east-1.amazonaws.com/mispichos.com.ar/user-interface-assets/wo_elementos/omi-min.png',
      date: 'Desde Azcapotzalco. 10/02/2021',
      comentario: 'Casi dejo a Turrón sin croquetas, les escribí a los chicos  y llegaron super rápido. Mil gracias por el servicio.'
    },
    {
      name: 'Cristina P.',
      sourse: 'https://s3.sa-east-1.amazonaws.com/mispichos.com.ar/user-interface-assets/wo_elementos/sofi-min.png',
      date: 'Desde Coyoacán. 05/02/2021',
      comentario: 'Fue mi primera compra y quedé encantada, me asesoraron en la compra, muy buenos precios y pagué en la puerta de mi casa.'
    },
  ]



  return (
    <div className='CarouselComits'>
      <h4>Lo que opinan de nosotros</h4>
      <Carousel
        showArrows={false}
        showStatus={false}
        showIndicators={true}
        showThumbs={false}
        swipeable
        autoPlay={true}
        infiniteLoop={true}
        stopOnHover={false}
      >
        {comentarios.map((comentario, o) =>
          <div className='Comentario' key={o}>
            <div className="Comentario-Head">
              <img src={comentario.sourse} alt="avatar" />
              <div>
                <h5 className="">{comentario.name} <small>{comentario.date}</small></h5>
                <div className="estrellas">
                  <FontAwesomeIcon icon={faStar} color={'gold'} />
                  <FontAwesomeIcon icon={faStar} color={'gold'} />
                  <FontAwesomeIcon icon={faStar} color={'gold'} />
                  <FontAwesomeIcon icon={faStar} color={'gold'} />
                  <FontAwesomeIcon icon={faStar} color={'gold'} />
                </div>
              </div>
            </div>
            <p>{comentario.comentario}</p>
          </div>
        )}
      </Carousel>
    </div>
  )
}

const TrustInUs = () => {
  return (
    <article className='TrustInUs'>
      <h4>Ya confian en nosotros</h4>
      <div className="GridSeis">
        <img src="https://oliver.pet/assets/forbes.png" alt="TrustInUs" />
        <img src="https://oliver.pet/assets/endeavor.png" alt="TrustInUs" />
        <img src="https://oliver.pet/assets/santander.png" alt="TrustInUs" />
        <img src="https://oliver.pet/assets/google.png" alt="TrustInUs" />
        <img src="https://oliver.pet/assets/facebook.png" alt="TrustInUs" />
        <img src="https://oliver.pet/assets/lanacion.png" alt="TrustInUs" />
      </div>
    </article>
  )
}

const CarouselPromotionalBanner = ({ data }) => {
  const history = useHistory();
  console.log('item.redirectBrand', data)
  if (!data) return null

  return (
    <div id='carrousel' className='CarouselPromotionalBanner'>
      <Carousel
        showArrows={false}
        showStatus={false}
        showIndicators={true}
        showThumbs={false}
        swipeable
        autoPlay={true}
        infiniteLoop={true}
        stopOnHover={false}
      >
        {data.map((item, i) =>
          <div className='P1' onClick={() => history.push({
            pathname: "/productos",
            search: '?' + item.categ + '=' + item.value_categ
          })}>
            <img className='CarouselPromotionalBanner-Image' alt={item.alt} src={item.sourse} />
          </div>
        )}
      </Carousel>
    </div>
  )
}
